import { configureStore } from '@reduxjs/toolkit';

import { globalReducer, payoutReducer, websocketReducer } from './slices';
import { depositApi } from './slices/deposit/services/depositApi';
import { globalApi } from './slices/global/services/globalApi';
import { payoutApi } from './slices/payout/services/payoutApi';
import { refundApi } from './slices/refund/services/refundApi';
import { topupsApi } from './slices/topups/services/topupsApi';

export const store = configureStore({
  reducer: {
    websocket: websocketReducer,
    [depositApi.reducerPath]: depositApi.reducer,
    payout: payoutReducer,
    [payoutApi.reducerPath]: payoutApi.reducer,
    [topupsApi.reducerPath]: topupsApi.reducer,
    global: globalReducer,
    [globalApi.reducerPath]: globalApi.reducer,
    [refundApi.reducerPath]: refundApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      depositApi.middleware,
      payoutApi.middleware,
      refundApi.middleware,
      globalApi.middleware,
      topupsApi.middleware,
    ]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
